import { useQuery } from '@tanstack/react-query';
import jobPostingApi from '../api/jobPosting';

const useMyJobs = ({params = {}}) => {
    const { data, isLoading, isError, error } = useQuery({
    queryKey: ['jobs', params],
    queryFn: async () => {
      const queryParams = new URLSearchParams({
        ...params,
      });
      Object.keys(queryParams).forEach(key => {
        if (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') {
          delete queryParams[key];
        }
      });
      const res = await jobPostingApi.getMyJobPostings(queryParams);
      return res.data;
    },
  });
  return { data, isLoading, isError, error}
}

export default useMyJobs